<template>
	<div>
		<egranty-section-divider
			text="Udostępnione oferty"
		/>
		<div v-for="offerBasicData in allowedOffersData" :key="offerBasicData.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{offerBasicData.offerCode}} &emsp; {{offerBasicData.title}}</h3>
					<egranty-icon-button
						label="Podgląd"
						icon="assignment"
						@click="() => viewOffer(offerBasicData)"
					/>
				</v-layout>
			</v-card>
		</div>
	</div>
</template>

<script>
	import {Offer} from "../../../api/generated/Offer";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AllowedOffersView",
		components: {EgrantyIconButton, EgrantySectionDivider},
		data () {
			return {
				allowedOffersData: []
			};
		},

		methods: {
			viewOffer (offerBasicData) {
				this.$router.openInNewTab("/view/contest/" + offerBasicData.contestId + "/offer/" + offerBasicData.id);
			}
		},

		mounted () {
			Offer.getAllowedBasicData(this, response => this.allowedOffersData = response);
		}
	};
</script>

<style scoped>
</style>